import React from 'react';
import { TableDataSortCase } from '../../../../../../store/deals/deals.types';
import { TableSortChevron } from '../Chevron/SortChevron';

type Props = {
  changeSortCase: () => void;
  dataSortCase: TableDataSortCase;
};

export const Account: React.FC<Props> = ({ changeSortCase, dataSortCase }) => {
  const clickSort = () => {
    changeSortCase();
  };

  const attrs = {
    wrapper: {
      className: 'table-header-account',
    },

    title: {
      className: 'table-header-account-title',
    },

    sortSection: {
      wrapper: {
        className: 'table-header-account__sort-section',
        onClick: clickSort,
      },

      ChevronBA: {
        activeCase: 'z-a' as TableDataSortCase,
        currentCase: dataSortCase,
      },

      ChevronAB: {
        activeCase: 'a-z' as TableDataSortCase,
        currentCase: dataSortCase,
        rotated: true,
      },
    },
  };
  return (
    <div {...attrs.wrapper}>
      <div {...attrs.title}>Account</div>
      <div {...attrs.sortSection.wrapper}>
        <TableSortChevron {...attrs.sortSection.ChevronBA} />
        <TableSortChevron {...attrs.sortSection.ChevronAB} />
      </div>
    </div>
  );
};
